import { Admin, CustomRoutes, Resource } from 'react-admin'
import { Route, BrowserRouter } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import Bots from './pages/Bots'
import BotAdm from './pages/BotAdm'
import Charges from './pages/Charges'
import authProvider from './providers/auth'
import { MyLayout } from './components/Layout'
import logo from './assets/images/logo.png'

import { FloatingWhatsApp } from 'react-floating-whatsapp'

const App = () => {
  return (
    <BrowserRouter>
      <Admin layout={MyLayout} loginPage={Login} dashboard={Dashboard} authProvider={authProvider}>
        <Resource name="root" />
        <CustomRoutes>
          <Route path="/bots" element={<Bots />} />
          <Route path="/charges" element={<Charges />} />
          <Route path="/bot_adm/:botId" element={<BotAdm />} />
        </CustomRoutes>
      </Admin>
      <FloatingWhatsApp
        phoneNumber="+5567981079863"
        accountName="Connectm"
        avatar={logo}
        statusMessage="Normalmente responde em 10 minutos"
        chatMessage="Olá 😄 No que posso ajudar?"
        placeholder="Digite uma mensagem"
        allowClickAway
        allowEsc
      />
    </BrowserRouter>
  )
}

export default App
